import { BaseApiService } from '../../../../../shared/base-service/base-api.service';
import { VehicleModel } from '../../../../models/vehicle.model';
import { Injectable } from '@angular/core';

@Injectable()
export class VehicleAddService extends BaseApiService {

    getModelByMakeId(makeId: number, model: string) {
        return this.get('vehicle/model/make/' + makeId + '/name/' + model);
    }
    getVehicleByTransactionID(businessTransactionId: number) {
        return this.get('Vehicle/Vehicle/BusinessTransactionID/' + businessTransactionId);
    }

    getAllBodyStylesByVehicleTypeId(vehicleTypeId: number) {
        return this.get( 'Vehicle/Vehicle/GetBodyStyleTypesByVehicleTypeId/' + vehicleTypeId);
    }

    getVehicleTypeBodyStyleTypeId(vehicleTypeId: number, bodyStyleTypeId: number) {
        return this.get('Vehicle/Vehicle/VehicleTypeBodyStyleType/VehicleType/' + vehicleTypeId + '/BodyStyleType/' + bodyStyleTypeId);
    }

    saveVehicle(vehicleModel: VehicleModel) {

        return this.post('vehicle/vehicle/', vehicleModel);
    }

    updateCorrectTitleVehicle(businessTransactionId: number, vehicleModel: VehicleModel) {
        return this.post('TitleRegistration/Title/UpdateCorrectTitleVehicle/' + businessTransactionId, vehicleModel);
    }

    getBrandsByVehicleType(vehicleId, vehicleTypeId) {
        return this.get('Vehicle/Vehicle/Vehicle/' + vehicleId + '/VehicleType/' + vehicleTypeId + '/Brands');
    }
}
